module.exports = __webpack_public_path__ + "static/img/img.3dda938e.png";